import Config from '@config';
import { ReferenceBook } from '@gasbi/shared';

import { injectSupplySlice } from '@/app/supplyApi';
import { FiltersGrid, Pagination } from '@/features/types';
import {
  infiniteQueryOptionsFn,
  normalizeInfiniteQueryData,
} from '@/features/utils';

export const NEGOTIATED_PRICE_SUPPLY_TARIFF_TYPE_ID =
  '01a0d0b6-4000-7c15-9e48-3a7f1b6d2e94';

export const isNegotiatedPriceSupplyTariffType = (typeId?: string | null) =>
  typeId === NEGOTIATED_PRICE_SUPPLY_TARIFF_TYPE_ID;

const api = injectSupplySlice({
  baseUrl: `${Config.VITE_API_URL}/supply-tariff-types`,
  tagTypes: ['ContractType'],
  endpoints: builder => ({
    getContractTypes: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: () => ['ContractType'],
    }),
    getContractTypesI: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions: infiniteQueryOptionsFn({ pageSize: 100 }),
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['ContractType'],
    }),
    getContractTypeById: builder.query<ReferenceBook, string>({
      query: id => ({ url: `/${id}`, method: 'GET' }),
      providesTags: (_result, _error, id) => [{ type: 'ContractType', id }],
    }),
  }),
});

export const contractTypesApi = api;

export const { useGetContractTypesQuery, useGetContractTypeByIdQuery } = api;

export const useGetContractTypesInfiniteQuery = normalizeInfiniteQueryData(
  api.useGetContractTypesIInfiniteQuery,
);
